class OnlineTaskFailedError extends Error {
    constructor(task) {
        super('Task failed');
        this.task = task;
    }
}

module.exports = OnlineTaskFailedError;
